export enum ProductTypeEnum {
	SimpleTicket = 1,
	SeasonTicket = 2,
	SingleEventPackage = 3,
	MultipleEventPackage = 4,
}
